// extracted by mini-css-extract-plugin
module.exports = {"title":"title___UZBZQ","url":"url___D8Qgl","navs":"navs___6QBn-","activated":"activated___3pMT_"};